export default {
  name: 'French Polynesia',
  phonePattern: '',
  postalCodePattern: '11111',
  singlePostalCode: '',
  postalCodeRegex: '^(987)([\\d]){2}$',
  language: '',
  dobFormat: 'DD MM YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/PF.js